import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
// import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    heading1: {
        fontSize: '15px',
        fontWeight: 700,
        color: '#000',
    },
    bottomLine: {
        // borderBottom: '1px solid #ccc !important',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
}));

const GeneralInfo = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });
    function StyledCheckbox(props) {
        const classes = useStyles();

        return (
            <Checkbox
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                inputProps={{ 'aria-label': 'decorative checkbox' }}
                {...props}
            />
        );
    }
    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 1. If any changes in Memorandum and Articles of Association, provide the same.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 2. New Agreements and contracts entered into by the company
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input name="firstname" type="text" placeholder="Enter Name" className="bottom" />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 3. Changes in the shareholdings of the Directors.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 4. Changes in Shareholders and their share of share holding in the company, if any.
                    Also provide Share Transfer Certificates.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 5. Specify changes if any, in company&apos;s accounting policies and procedures manual
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 6. Specify Changes, if any in company&apos;s internal control policies and procedures.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 7. Access to books of account of the company for the financial year.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 8. Any renewal or changes in the Rental agreement.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 9. Copy of the Board Meeting Minutes and the Resolutions passed if any during such
                    meetings.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.subheading}>
                    <StyledCheckbox defaultChecked /> 10. Details of all Related Party transactions carried out during the year.
                </Typography>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="standard-adornment-amount">Remarks by Audit Team</InputLabel>
                    <Input
                        name="firstname"
                        type="text"
                        placeholder="Enter Name"
                        className="bottom"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.firstname}
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default GeneralInfo;
